"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const traineeList_1 = __importDefault(require("./graphql/query/traineeList"));
class TraineeListApi {
    constructor(graphqlClient) {
        this.graphqlClient = graphqlClient;
        this.getMembersList = async (_application) => {
            const { trainees: { items }, } = await this.graphqlClient.fetch("traineeList", traineeList_1.default, {});
            return items.map(({ id, member }) => ({
                id: id.toString(),
                member: {
                    ...member,
                    id: member.id.toString(),
                },
            }));
        };
    }
}
exports.default = TraineeListApi;
//# sourceMappingURL=TraineeListApi.js.map